import React, {PureComponent, useCallback, useContext, useEffect, useMemo, useState} from "react";
import {
    CartesianGrid, Line, LineChart, PieChart, Pie,
    Sector, XAxis, YAxis, Tooltip, ReferenceLine,
    ReferenceArea, ResponsiveContainer, Label, LabelList, Brush,
    ScatterChart, ZAxis, Legend, Scatter, Bar, BarChart, Text, Area, AreaChart, Customized,
    RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Cell
} from 'recharts';
import {PieChartWapInterFace} from "./pie_chart";
import styled from "styled-components";



export const ChartWidget: React.FC<PieChartWapInterFace> = ({list,totalNumner,title}) => {
    // const [listData,setListData] = useState<{ name: string, value: number, color: string }[]>(list);


    return (<PieChart width={240} height={240}>
        <Pie
            activeIndex={0}
            activeShape={(ev) => renderActiveShape(ev,title)}
            data={list}
            cx={115}
            cy={115}
            innerRadius={75}
            outerRadius={90}
            // fill="#8884d8"
            startAngle={90} endAngle={-270}
            dataKey="value"
            stroke="none"
            // label
            // onMouseEnter={onPieEnter}
        >
            {
                list.map((ev, i) => <Cell key={`cell-${i}`} fill={ev.color}/>)
            }
        </Pie>
        <Tooltip content={(ev:any)=>{
            if(ev.payload.length != 0 && (ev.payload[0].name == list[0].name))
            return CustomTooltip(ev.payload[0].name,ev.payload[0].value/totalNumner);
            else return null;
        }} />
    </PieChart>);
};




const CustomTooltip = (name:string,total:number) => {
    return <StyleTooltip>
        {`${name} ${(total * 100).toFixed(2)}`}%
    </StyleTooltip>


};


const StyleTooltip = styled.div`

background: #ffffff;
color: black;
font-size: 14px;
padding: 5px;
box-sizing: border-box;
`;





    const renderActiveShape = (props: any,title:string) => {
    const RADIAN = Math.PI / 180;
    const {
        cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
        fill, payload, percent, value,
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
        <g>
            {/*<text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>{payload.name}</text>*/}
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius -2}
                outerRadius={outerRadius + 4}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
            />
            {/*<Sector*/}
            {/*cx={cx}*/}
            {/*cy={cy}*/}
            {/*startAngle={startAngle}*/}
            {/*endAngle={endAngle}*/}
            {/*innerRadius={outerRadius + 6}*/}
            {/*outerRadius={outerRadius + 10}*/}
            {/*fill={fill}*/}
            {/*/>*/}
            {/*<path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />*/}
            {/*<circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />*/}
            {/*<text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#fff">{`${(percent * 100).toFixed(2)}%`}</text>*/}
            {/*<text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={2} fontSize='12px' textAnchor={textAnchor} fill="#fff">*/}
               {/*{title}*/}
            {/*</text>*/}
            {/*<Tooltip />*/}
        </g>
    );
};

